import template from './langSelectBox.component.html';
import Cookies from 'js-cookie';
import {lazyRegister} from '@/Core/lazyRegister';
import {WebshopRootScope} from "@/models";

lazyRegister.component('langSelectBox', {
    template: template,
    bindings: {},
    controller: [
        '$element',
        '$scope',
        '$rootScope',
        function ($element,
                  $scope,
                  $rootScope: WebshopRootScope
        ) {
            const ctrl = this;

            $scope.langItems = [
                'EN',
                'DA',
                'DE',
                'FR',
                'NL',
                'NB',
                'SV',
                'PL',
                'ES',
                'PT'
            ];

            ctrl.$onInit = function () {
                $element.addClass('lang-select-box');
                $rootScope.selectedLang = Cookies.get('lang_code_admin') || 'EN';
                updateLangTag($rootScope.selectedLang);
            };

            $scope.changeLang = async () => {
                updateLangTag($rootScope.selectedLang);
                $rootScope.$broadcast('onLangChanged', $rootScope.selectedLang);
                
                Cookies.set('lang_code_admin', $rootScope.selectedLang, {
                    expires: 365,
                    path: '/'
                });

                await $rootScope['getLangData']($rootScope.selectedLang);
            }

            function updateLangTag(lang) {
                document.documentElement.setAttribute('lang', lang.toLowerCase());
            }
        }
    ]
});